import { render, staticRenderFns } from "./EventCosts.vue?vue&type=template&id=2ebcc204&scoped=true&"
import script from "./EventCosts.vue?vue&type=script&lang=js&"
export * from "./EventCosts.vue?vue&type=script&lang=js&"
import style0 from "./EventCosts.vue?vue&type=style&index=0&id=2ebcc204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebcc204",
  null
  
)

export default component.exports